<template>
  <div>
    <van-nav-bar
        title="支付明细"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

    <div>
        <van-cell-group  v-for="(item, index) in payList" :key="index">
     
             <!-- <van-cell :title="item.corpName" :value="item.payAmt/100|numFilter2" :label="item.payDate">-->
             <!-- 使用 icon 插槽来自定义左侧图标 -->
			 <van-cell :title="item.corpName" :value="item.payAmt/100|numFilter2" :label="item.payDate">
            <template #icon>
                <van-image
                    width="50"
                    height="50"
                    :src="(item.payMode == 'p' ?  icon[0] : icon[1])"
                    round
                />
            </template>
            </van-cell>
        </van-cell-group>
		<div v-show="ept_list_tip_show_flag" style="text-align:center"> 未查到您的支付记录</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
  },
  data() {
    return {
        payList:[],
		icon:[
			require('../../static/img/payment.png'),
			require('../../static/img/back.png'),
		],

		ept_list_tip_show_flag:false,
		
    };
  },
	methods: {
		init(){

			let data ={lysCstUserId: sessionStorage.getItem('lysCstUserId')};

			console.log(data);

			this.$getRequestData('queryPayLog', data)
			.then(result => {
				console.log(result.bizData)
				this.payList = result.bizData;
				if(this.payList.length == 0)
				{
					this.ept_list_tip_show_flag = true;
				}else{
					this.ept_list_tip_show_flag = false;
				}
			})
		},

        onClickLeft(){
            history.go(-1);
        },
        onClickRight()
        {
             this.$router.push({ path: '/' })
        }, 
	},

	computed: {	
		
	},
	watch: {},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.init()
	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {},
	// 生命周期 - 创建之前
	beforeCreate() {},
	// 生命周期 - 挂载之前
	beforeMount() {
		
	},
	// 生命周期 - 更新之前
	beforeUpdate() {},
	// 生命周期 - 更新之后
	updated() {},
	// 生命周期 - 销毁之前
	beforeDestroy() {},
	// 生命周期 - 销毁完成
	destroyed() {},
	// 如果页面有keep-alive缓存功能，这个函数会触发
	activated() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类

.van-cell {
	height: 90px;
	align-items: center;
	.van-cell__title{
		flex: 1;
		text-align: left;
		margin-left: 12px;
	}
	.van-cell-value {
		font-size: 18px;
	}
}
</style>
